<template>
<div class="ex-wrapper">
		<div class="heading">Form File</div>
		<div class="description">All Information about Form File.</div>

    <div class="example-set">
      <div class="row">
        <div class="col-md-3">
          <div class="file-group">
            <div class="label">Icon Input</div>
            <div class="name-file _bg-grey-disable"></div>
            <span class="icon fa fa-paperclip" aria-hidden="true"></span>
            <div class="validator-text"></div>
          </div> 
        </div>
        <div class="col-md-9">
        </div>
      </div>
    </div>
		
	</div>
</template>

<script>
var Prism = require('prismjs')
var code = `

`
var html = Prism.highlight(code, Prism.languages.markup)

export default {
  name: 'ex-file',
  data () {
    return {
      tag: html
    }
  },
  created () {
    // console.log(this.tag)
  }
}
</script>


// WEBPACK FOOTER //
// ex-file.vue?cfd4bc72